module.exports = __webpack_public_path__ + "static/media/mid_QR_code.7dc30fff.png";